module.exports = __webpack_public_path__ + "img/Stripe_logo.5b8b1021.jpg";